import { Flex } from "styles/utility-components";

import { SpendFilters } from "lib/hooks/api/spend/spendFilters";
import { SpendView } from "../hooks/useSpendUrlState";
import { SpendTrendsControls } from "../SpendTrendsControls";
import { BuyerTypeRankingView } from "./BuyerTypeRankingView";
import { SpendOverTimeView } from "./SpendOverTimeView";
import { SpendRankingView } from "./SpendRankingView";

type Props = {
  filters: SpendFilters;
  view: SpendView;
  onViewChange: (update: Partial<SpendView>) => void;
};

/**
 * The Trends mode of the spend page: the controls for how to read the transactions, then
 * the view they pick. The controls stay put even when that view has nothing to show.
 */
export function SpendTrendsView({ filters, view, onViewChange }: Props) {
  return (
    <Flex column gap={24}>
      <SpendTrendsControls view={view} onChange={onViewChange} />
      <TrendsBody filters={filters} view={view} onViewChange={onViewChange} />
    </Flex>
  );
}

function TrendsBody({ filters, view, onViewChange }: Props) {
  const { trendsGroupBy } = view;
  if (trendsGroupBy === "time") {
    return <SpendOverTimeView filters={filters} interval={view.interval} />;
  }
  if (trendsGroupBy === "buyerTypes") {
    return <BuyerTypeRankingView filters={filters} view={view} onViewChange={onViewChange} />;
  }
  return (
    <SpendRankingView
      // A new search, grouping or order is a fresh ranking: back to page one, nothing ticked.
      key={JSON.stringify([filters, trendsGroupBy, view.measure, view.sortOrder])}
      filters={filters}
      entity={trendsGroupBy}
      view={view}
      onViewChange={onViewChange}
    />
  );
}
